import PromoBanner from "@/components/PromoBanner";
import { DEFAULT_PROMO_DATA } from "./constants";

export type HighlightsPromoProps = {
  headline?: string;
  subtext?: string;
  infoText?: string;
  ctaElement?: React.ReactNode;
  headlineMobile?: string;
  subtextMobile?: string;
};

export default function HighlightsPromo({
  headline,
  subtext,
  infoText,
  ctaElement,
  headlineMobile,
  subtextMobile,
}: HighlightsPromoProps) {
  const promoHeadline = headline || DEFAULT_PROMO_DATA.headline;
  const promoSubtext = subtext || DEFAULT_PROMO_DATA.subtext;
  const promoInfoText = infoText || DEFAULT_PROMO_DATA.infoText;
  const promoHeadlineMobile =
    headlineMobile || headline || DEFAULT_PROMO_DATA.headline;
  const promoSubtextMobile =
    subtextMobile || subtext || DEFAULT_PROMO_DATA.subtext;

  return (
    <div className="pb-8 md:pb-16">
      <PromoBanner
        variant="compactPDP"
        compact={{
          headline: promoHeadline,
          subtext: promoSubtext,
          infoText: promoInfoText,
          headlineMobile: promoHeadlineMobile,
          subtextMobile: promoSubtextMobile,
        }}
        ctaElement={ctaElement}
      />
    </div>
  );
}
